import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import axios from "axios";
import SignatureManager from "../../components/SignatureManager";
import ReviewManager from "../../components/ReviewManager";
import CompanyAddress from "../../components/CompanyAddress";
import "../../styles/Form.css";
import logo from "../../images/logo.png";

const BackgroundCheck = () => {
  const API_BASE = process.env.REACT_APP_API_BASE_URL;
  const [username, setUsername] = useState("");
  const userId = localStorage.getItem("userId");
  const navigate = useNavigate();
  const { id: paramId } = useParams();
  const userRole = localStorage.getItem("userRole");
  const isAdmin = userRole === "1";
  const [isSigned, setIsSigned] = useState(false);
  const [signedDate, setSignedDate] = useState("");
  const effectiveUserId = isAdmin && paramId ? paramId : userId;
  const location = useLocation();
  const isSlidePage = location.pathname.startsWith("/slide/");

  useEffect(() => {
    const fetchUserName = async () => {
      try {
        const token = localStorage.getItem("token");
        const url = isAdmin
          ? `${API_BASE}/api/users/${effectiveUserId}`
          : `${API_BASE}/api/user/profile`;

        const res = await axios.get(url, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const { first_name, last_name } = res.data;
        setUsername(`${first_name} ${last_name}`);
      } catch (err) {
        console.error("Error fetching user name:", err);
      }
    };

    const fetchTaskStatus = async () => {
      try {
        const res = await axios.get(
          `${API_BASE}/api/usertasks/status/${effectiveUserId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );

        const TASK_ID = 23; // verify this matches nwt_tasks.t_id for LEEP
        const idKey = String(TASK_ID);
        const nameKey = "backgroundcheck";

        const status =
          res.data.status?.[idKey] ??
          res.data.status?.[nameKey] ??
          "not_completed";

        const signed = status === "review" || status === "completed";

        if (signed) {
          setIsSigned(true);
          setSignedDate(
            res.data.signdates?.[idKey] ?? res.data.signdates?.[nameKey]
          );
        }
      } catch (err) {
        console.error("Error checking task status:", err);
      }
    };

    fetchUserName();
    fetchTaskStatus();
  }, [API_BASE, userId, isAdmin, effectiveUserId]);

  return (
    <>
      {/* 🔝 Top row */}
      <div className="d-flex justify-content-between align-items-center pt-3 px-3">
        {!isSlidePage && (
          <span style={{ fontSize: "18px", fontWeight: "500" }}>
            Consent to Background Checks
          </span>
        )}
        <div className="ms-auto">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => navigate(-1)}
          >
            {isSlidePage ? "Close" : "Return"}
          </button>
        </div>
      </div>

      {/* Slide-specific heading */}

      {/* Main Content */}
      <div
        className={`form-wrapper my-4 print-area ${isSlidePage ? "slide-narrow" : "px-4"}`}
        style={{ fontSize: "15px", lineHeight: "1.6" }}
      >
        {/* Logo/title block for non-slide */}
        {!isSlidePage && (
          <div className="row align-items-center mb-4">
            <div className="col-3 text-start">
              <img
                src={logo}
                alt="Company Logo"
                style={{ width: "150px", height: "auto" }}
              />
            </div>
            <div className="col-6 text-center">
              <h2 className="m-0">Consent to Background Checks</h2>
            </div>
            <CompanyAddress />
          </div>
        )}

        {isSlidePage && (
          <div
            className="d-flex justify-content-between align-items-center px-3"
            style={{
              paddingTop: "16px",
              paddingBottom: "12px",
              marginBottom: "16px",
              borderBottom: "1px solid #ccc",
            }}
          >
            <h4
              className="m-0"
              style={{
                fontWeight: "500",
                color: "#333",
                fontSize: "18px",
              }}
            >
              Review and Sign Consent – Consent to Background Check
            </h4>
          </div>
        )}

        <p className="mt-4">
          New-Way Transport Inc. is hereby advising you that, for employment
          purposes, including but not limited to initial employment (eg.
          processing your employment application), promotion, reassignment, or
          retention, as applicable...
        </p>

        <p className="mt-5">
          If a Commercial Driver's License Information System (CDLIS) report is
          requested...
        </p>

        <p className="mt-5">
          I understand that my Potential Employer may take adverse action...
        </p>

        <ul>
          <li>Employer must notify me in writing of any such adverse action</li>
          <li>I have the right to receive a copy of the driving record...</li>
          <li>
            I have the right to receive a summary of my rights under the Fair
            Credit Reporting Act.
          </li>
          <li>
            I have the right to know the name, address and phone number...
          </li>
          <li>
            I have the right to obtain a free copy of my driving record...
          </li>
          <li>I have the right to dispute the accuracy or completeness...</li>
        </ul>

        <hr className="my-5" />

        <form>
          <div className="row mb-3 mt-5">
            <div className="col">
              <label className="form-label">Employee Name</label>
              <input
                type="text"
                className="form-control"
                value={username}
                readOnly
              />
            </div>
            <div className="col">
              <label className="form-label">Date</label>
              <input
                type="text"
                className="form-control"
                value={
                  isSigned && signedDate
                    ? new Date(signedDate).toLocaleDateString()
                    : new Date().toLocaleDateString()
                }
                readOnly
              />
            </div>
          </div>
        </form>

        {userId && (
          <>
            <SignatureManager
              taskName="backgroundcheck"
              taskId={23}
              userId={effectiveUserId}
              isAdmin={isAdmin}
            />
            <ReviewManager
              taskName="backgroundcheck"
              taskId={23}
              userId={effectiveUserId}
              isAdmin={isAdmin}
            />
          </>
        )}
      </div>
    </>
  );
};

export default BackgroundCheck;
